import { useGetMyTeacherEventsQuery } from '@school_ify/schoolify-repository/src/teacher/types';

import EventsList from './components/EventsList';

import './Events.scoped.scss';

const Events: React.FC = () => {
  const { data } = useGetMyTeacherEventsQuery({
    variables: {},
  });

  return <div className="wrapper">{data && <EventsList events={data.events} />}</div>;
};

export default Events;
